import moment from 'moment';
import _ from 'lodash';

export const DATE_FORMAT = 'YYYY-MM-DD';
export const DAY_FORMAT = 'MMM d';
export const TIME_FORMAT = 'HH:mm';
export const DEFAULT_FORMATTED_HOUR = '09:00';

export const getRecurrenceTextByDate = (type, time, startDateValue) => {
  const formattedText = preText => {
    if (preText && time) return `(${preText} at ${time})`;
    else if (preText) return `(${preText})`;
    else if (time) return `(at ${time})`;
    return '';
  };

  const formattedDate = (date, dateFormat) => moment(date).format(dateFormat || 'ddd');
  const lastDays = [28, 29, 30, 31];
  const dayIsLastOfMonth = _.includes(lastDays, _.toInteger(formattedDate(startDateValue, 'D')));

  const RECURRENCE_TYPES = {
    DAY: 'day',
    WEEK: 'week',
    BI_WEEKLY: 'bi_weekly',
    MONTH: 'month',
    QUARTER: 'quarter',
    YEAR: 'year',
  };

  switch (type.value) {
    case RECURRENCE_TYPES.DAY:
      return `${type.label} ${formattedText()}`;
    case RECURRENCE_TYPES.WEEK:
    case RECURRENCE_TYPES.BI_WEEKLY:
      return `${type.label} ${formattedText(`${formattedDate(startDateValue)}`)}`;
    case RECURRENCE_TYPES.MONTH:
      return `${type.label} ${formattedText(formattedDate(startDateValue, 'Do'))}`;
    case RECURRENCE_TYPES.QUARTER:
      if (dayIsLastOfMonth) {
        return `${type.label} ${formattedText(formattedDate(startDateValue, 'Do'))}`;
      }
      return `${type.label} ${formattedText(formattedDate(startDateValue, 'Do'))}`;
    case RECURRENCE_TYPES.YEAR:
      return `${type.label} ${formattedText(formattedDate(startDateValue, 'MMM Do'))}`;
    default:
      return '';
  }
};
